<ng-progress [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"></ng-progress>
<div class="subBlockContainer entry-loader" id="qoutesitem">
  <div class="subBlockContent" id="price-list-detail">
    <child-header [title]="quoteId" (closeEvent)="close()"></child-header>
    <div class="item-title-wrapper">
<!--      <div class="page-title-wrapper">-->
<!--        <div class="title blade-title-font">-->
<!--          Quote ID {{quoteDetail?.quoteHeader?.quoteId}}-->
<!--        </div>-->
<!--        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>-->
<!--      </div>-->
      <!-- <p class="title-wrapper orderitem-title-position">Quote ID {{quoteDetail?.quoteHeader?.quoteId}}
        <i class="material-icons pullfloat-right" (click)="close()">close</i>
      </p> -->

      <!-- <div>
          <p class="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras rhoncus enim sed velit porta venenatis. Nam consectetur, tortor sit amet laoreet pellentesque, augue tortor luctus libero, eu commodo arcu lacus in lectus.
            Praesent venenatis semper justo et pellentesque. Sed ut imperdiet ligula, nec feugiat felis. Nulla ullamcorper eget mi vitae lacinia. Fusce et pharetra dolor, non lacinia risus. */</p>
        </div> -->
      <div class="row" *ngIf="loadContent">
        <div class="col-md-4">
          <div class="infoSection infoSection-detailBox-padding shadow-wrapper">
            <div class="infoSection-title-bold">SUMMARY</div>
            <div class="row infowrapper">
              <div class="col-md-6">
                <div class="section-divider">
                  <div>QUOTE ID</div>
                  <div>{{quoteDetail?.quoteHeader?.quoteId}}
                    v{{quoteDetail?.quoteHeader.lastVersion}}</div>
                </div>
                <div class="section-divider">
                  <div>Total EX</div>
                  <div>
                    {{quoteDetail?.quoteHeader?.totalValue | currency:'AUD':'symbol-narrow':'.2-2'}}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="section-divider">
                  <div>RESELLER REF</div>
                  <div>{{quoteDetail?.quoteHeader?.custReference}}</div>
                </div>
                <div class="section-divider">
                  <div>EXPIRE DATE</div>
                  <div>
                    {{quoteDetail?.quoteHeader?.expiryDate.split("-").join("/")}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="infoSection infoSection-detailBox-padding shadow-wrapper">
            <div class="infoSection-title-bold">END USER</div>
            <section class="address-wrapper" *ngIf="quoteDetail?.endUser?.address1">
              <div>{{quoteDetail?.endUser.companyName}}</div>
              <div *ngIf="quoteDetail?.endUser?.address1">
                <b>{{quoteDetail?.endUser.address1}}</b>
              </div>
              <span>{{quoteDetail?.endUser.suburb}}, </span>
              <span>{{quoteDetail?.endUser.postcode}}</span>
              <span>{{quoteDetail?.endUser.state}}</span>
              <div>{{quoteDetail?.endUser.country}}</div>
            </section>
            <!-- <section class="address-wrapper" *ngIf="!quoteDetail?.endUser.address1">
              <div class="row">
                <div class="col-4"><img style="width:100%" src="../images/new_ui/no-endUser.png"></div>
                <div class="col-8"
                  style="color:#1B1C20;font-size:14px;margin:auto;text-transform: none;font-weight:400">
                  We
                  couldn't find any saved end users for this quote
                  <div class="button-wrapper">
                      <button class="createdbtn">Create now</button>
                    </div>
                </div>

              </div>
            </section> -->
          </div>
        </div>
        <div class="col-md-4">
          <div class="infoSection infoSection-detailBox-padding shadow-wrapper">
            <div class="infoSection-title-bold">DELIVERY ADDRESS</div>
            <section class="address-wrapper" *ngIf="quoteDetail?.deliveryAddress?.address1">
              <div style="font-weight:400">{{quoteDetail?.deliveryAddress.companyName}}</div>
              <div *ngIf="quoteDetail?.deliveryAddress?.address1">
                <b style="font-weight:400">{{quoteDetail?.deliveryAddress.address1}}</b>
              </div>
              <span style="font-weight:400">{{quoteDetail?.deliveryAddress.suburb}}, </span>
              <span style="font-weight:400">{{quoteDetail?.deliveryAddress.postcode}}</span>
              <span style="font-weight:400">{{quoteDetail?.deliveryAddress.state}}</span>
              <div style="font-weight:400">{{quoteDetail?.deliveryAddress.country}}</div>
            </section>
            <!-- <section class="address-wrapper" *ngIf="!quoteDetail?.deliveryAddress.address1">
              <div class="row">
                <div class="col-4"><img style="width:100%" src="../images/new_ui/no-deliveryLoc.png"></div>
                <div class="col-8"
                  style="color:#1B1C20;font-size:14px;margin:auto;text-transform: none;font-weight:400">
                  We
                  couldn't find any saved addresses for this order
                  <div class="button-wrapper">
                      <button class="createdbtn">Create now</button>
                    </div>
                </div>
              </div>
            </section> -->
          </div>
        </div>
      </div>
    </div>

    <div class="inner-subBlock-wrapper" *ngIf="loadContent">
      <div class="filter-wrapper">
        <div class="searchInputGroup">
          <div class="searchIcon">
            <img src="../images/new_ui/filter.png">
          </div>
          <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
            onblur="this.placeholder='Filter'" [(ngModel)]="filterInput" (ngModelChange)="onChange()">
          <!-- <div>
              <div id="catDownloadButton"></div>
            </div> -->
          <!-- <div>
              <p class="downloadDescription">Download to Excel</p>
            </div> -->
        </div>
      </div>
      <ng-container *ngIf="hasEmptyFilterResult">
        <div class="noResult-wrapper">
          <div class="top-divider"></div>
          <div><img src="../images/new_ui/no-found.png"></div>
          <div>No results found</div>
          <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
          <button class="button button-red button-large" (click)="filterReset()">Try again</button>
          <div class="noResult-feedback">Send Feedback</div>
        </div>
      </ng-container>
      <!--  -->
      <ng-container *ngIf="loadContent">
        <div class="top-divider"></div>
        <div *ngIf="!hasEmptyFilterResult">
          <div class="shared-outer-wrapper">
            <form #f="ngForm">
              <table matSort (matSortChange)="sortData($event)" class="white">
                <thead>
                  <tr class="row">
                    <th mat-sort-header="stockDesc" class="col-2">STOCK CODE</th>
                    <th mat-sort-header="stockOnHand" class="col-6">DESCRIPTION</th>
                    <th mat-sort-header="price" class="col-1">QTY</th>
                    <th mat-sort-header="quantity" class="col-1" style="padding-left: 23px">PRICE</th>
                    <th mat-sort-header="lineTotal" class="col-2" style="padding-left: 28px; padding-right: auto;">
                      SUBTOTAL</th>
                  </tr>
                </thead>
                <tbody>

                  <ng-container *ngFor="let item of sortedData | TableFilterMultiple:['stockDesc',
                'stockOnHand', 'price', 'quantity', 'lineTotal'] : filterInput ; index as i">
                    <tr class="row">

                      <div class="col-2 text-ellipsis">
                        {{item?.stockCode}}
                      </div>

                      <div class="col-6 align-left center-text font-color padding-r-x30">
                        <div class="result_desc">
                          {{item?.stockDesc}}
                        </div>
                      </div>

                      <div class="col-1 align-left center-text font-color padding-r-x25">
                        <input class="align-center input-wrapper input-wrapper-small" type="text" integerOnly
                          [(ngModel)]="item.quantity" name="quantity_{{i}}"
                          (ngModelChangeDebounced)="updateQty($event, i)">
                      </div>

                      <div class="col-1 align-center font-color margin-t-x4">
                        <div class="quantity">{{item?.price | currency:'AUD':'symbol-narrow':'.2-2'}}</div>
                      </div>

                      <div class="col-2 align-right center-text font-color padding-r-x70">
                        {{item?.lineTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</div>

                      <div class="col-2">

                      </div>

                      <div class="col-6">
                        <div class="result-info">
                          <div class="produc-secondary-title-wrapper">
                            <span>
                              <span class="bold-text">Min:&nbsp;</span>
                              <span>{{item?.min}}</span>
                            </span>

                            <span style="margin-left: 4rem;">
                              <span class="bold-text">Max:&nbsp;</span>
                              <span>{{item?.max}}</span>
                            </span>
                            <!-- <span *ngIf="item?.stockCode || !item?.stockCode ==''">
                            <span class="bold-text">SKU:&nbsp;</span>
                            <span>{{item?.stockCode}}</span>
                            <span
                              *ngIf="item?.stockType == 'KA' || item?.stockType == 'KB' || item?.stockType == 'CA' || item?.stockType == 'CB'"
                              class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                          </span>
                          <span *ngIf="item?.stockType == 'KA' || item?.stockType == 'KB'">
                            <span class="bold-text">BUNDLE&nbsp;</span>
                          </span>
                          <span *ngIf="item?.stockType == 'CA' || item?.stockType == 'CB'">
                            <span class="bold-text">COMPONENT&nbsp;</span>
                          </span> -->
                          </div>
                        </div>
                      </div>

                    </tr>

                  </ng-container>

                  <tr class="row" *ngIf="sortedData?.length==0">
                    <div class="col-12 align-center"> there is no available items</div>
                  </tr>

                  <tr class="row totalPrice-wrapper" style="justify-content: center;">
                    <button class="button button-red button-large" [disabled]="sortedData?.length==0"
                      (click)="viewSummary()">View
                      Summary</button>
                  </tr>
                  <!-- <tr class="row totalPrice-wrapper">
                  <div class="col-md offset-md-7">Total (ex. GST)</div>
                  <div class="col-md price">
                    {{quoteDetail?.quoteHeader?.totalValue | currency:'AUD':'symbol-narrow':'.2-2'}}</div>
                  <div class="col-md-1" style="max-width: 5%"></div>
                </tr> -->

                </tbody>
              </table>
            </form>
          </div>
        </div>
        <div class="button-wrapper" style="text-align: center;">
          <!-- <button class="button button-red button-large placeOrderbtn">Place order</button> -->
        </div>
      </ng-container>
      <!--  -->
    </div>
    <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="true"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
  <router-outlet></router-outlet>
</div>
